import styled from 'styled-components';
import React, { FC, ReactElement } from 'react';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import useTranslator from '../../../hooks/useTranslator';
import { SetListingPageStateFunc } from '../../../hooks/ListingPage/useListingPageUrlState';

interface ClearAllFiltersButtonProps {
    updateFilters: SetListingPageStateFunc;
}

const StyledClearFiltersButton = styled.div`
    margin-top: 15px;
    ${forTablet`
        margin-top: 10px;
    `}
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const ClearAllFiltersButton: FC<ClearAllFiltersButtonProps> = ({ updateFilters }): ReactElement => {
    const t = useTranslator();
    return (
        <StyledClearFiltersButton onClick={() => updateFilters({ appliedFilters: [] })}>
            {t('Reset filter')}
        </StyledClearFiltersButton>
    );
};

export default ClearAllFiltersButton;
